import { getRandomId } from "client/utils/getRandomId";
import { selectText } from "client/utils/selectText";
import { addTextBox } from "store/features/memeGenerator/actions";
import { useAppDispatch } from "store/store";

export const useOptions = () => {
    const dispatch = useAppDispatch();
    const handleAddTextBox = () => {
        const id = getRandomId();
        dispatch(addTextBox({ id }));
        setTimeout(() => {
            const textBox = document.getElementById(`textBox-${id}`);
            textBox && selectText(textBox);
        }, 50);
    };
    return { handleAddTextBox };
};
